import util from './shared/util.js';
import config from '../config.js';

var servicesURL = `${config.server.url}:${config.server.webServicesPort}/being/`;

class cdoBeing {
    routinePortraits = (idEntity, callback) => util.getJSON(`${servicesURL}routine-portraits?idEntity=${encodeURIComponent(idEntity)}`, callback);
    saveRoutinePortraitSchedule = (data, callback) => util.putJSON(`${servicesURL}routine-portraits/routine`, data, callback);
    configureRoutinePortrait = (data, callback) => util.putJSON(`${servicesURL}routine-portraits/assignment`, data, callback);
    generateRoutinePortrait = (data, callback) => util.putJSON(`${servicesURL}routine-portraits/generate`, data, callback);
    deleteRoutinePortrait = (data, callback) => util.putJSON(`${servicesURL}routine-portraits/delete`, data, callback);
    planning = (idEntity, callback) => util.getJSON(`${servicesURL}planning?idEntity=${encodeURIComponent(idEntity)}`, callback);
    savePlanning = (data, callback) => util.putJSON(`${servicesURL}planning`, data, callback);
    reviewPlanning = (data, callback) => util.putJSON(`${servicesURL}planning-review`, data, callback);
    create = (data, callback) => {
        util.putJSON(servicesURL + 'create', data, callback);
    }

    generateItemSuggestions = (data, callback) => {
        util.putJSON(servicesURL + 'generate-item-suggestions', data, callback);
    }

    generateSuggestedItem = (data, callback) => {
        util.putJSON(servicesURL + 'generate-suggested-item', data, callback);
    }

    generateRoutines = (data, callback) => {
        util.putJSON(servicesURL + 'generate-routines', data, callback);
    }

    update = (data, callback) => {
        util.putJSON(servicesURL + 'update', data, callback);
    }

    selectAll = (callback) => {
        util.getJSON(`${servicesURL}select-all`, callback);
    }

    selectAllDetails = (callback) => {
        util.getJSON(`${servicesURL}select-all-details`, callback);
    }

    select = (idEntity, callback) => {
        util.getJSON(`${servicesURL}select?idEntity=${encodeURIComponent(idEntity)}`, callback);
    }

    selectPortraitImage = (idEntity, callback) => {
        util.getJSON(`${servicesURL}select-portrait-image?idEntity=${encodeURIComponent(idEntity)}`, callback);
    }

    selectPortraitImages = (idEntity, callback) => {
        return util.getJSON(`${servicesURL}select-portrait-images?idEntity=${encodeURIComponent(idEntity)}`, callback);
    }

    savePortraitImage = (data, callback) => {
        util.putJSON(servicesURL + 'save-portrait-image', data, callback);
    }

    savePortraitCandidate = (data, callback) => {
        return util.putJSON(servicesURL + 'save-portrait-candidate', data, callback);
    }

    setPrimaryPortraitImage = (data, callback) => {
        return util.putJSON(servicesURL + 'set-primary-portrait-image', data, callback);
    }

    finalizeCharacterCreation = (data, callback) => {
        return util.putJSON(servicesURL + 'finalize-character-creation', data, callback);
    }
}

const cdo = new cdoBeing();
export default cdo;
